import { Box, IconButton, Stack } from "@mui/material";
import { Component } from "react";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import MainMenu from "./MainMenu";
import Cookies from "universal-cookie";
import { MdExitToApp } from "react-icons/md";
import { IoIosColorPalette } from "react-icons/io";

class Base extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toLogin: false
        }
        this.cookies = new Cookies();
        let user = this.cookies.get('user');
        if (!user) {
            this.state.toLogin = true;
        }
    }

    render() {
        return (
            <>
                {!this.state.toLogin && <><Stack direction="row" width="100%" height="40px" bgcolor="primary.main" alignItems={"center"} sx={{ zIndex: 99999 }} position="fixed">
                    <Box component="img" sx={{ ml: 1.5, filter: "invert(1)" }} src="res/inventariano.png" height={12} />
                    <Box flex={1} />
                    {/* <IconButton title="Mudar tema" onClick={this.props.toggleTheme}><IoIosColorPalette color="black" /></IconButton> */}
                    <IconButton title="Sair" onClick={e => {
                        this.cookies.remove('user');
                        this.setState({ toLogin: true });
                    }}><MdExitToApp color="white" /></IconButton>
                </Stack>
                    <Stack direction="row" height={{ xs: 'calc(100vh -  70px)', sm: 'calc(100vh - 40px)' }} >
                        <Box >
                            <Stack component="nav" height="100%" spacing={1} justifyContent="center" sx={{ overflowY: 'auto' }}>
                                <MainMenu />
                            </Stack>
                        </Box>
                        <Outlet />
                    </Stack></>}
                {this.state.toLogin && <Navigate to='/login' />}
            </>
        );
    }
}

const wrapper = Component => props => {
    //const { toggleTheme } = useOutletContext();
    return <Component {...props} />;
};

export default wrapper(Base);
